import React from "react";
import { useQuery } from "@apollo/client";

import RoyaltiesNoActivity from "./RoyaltiesNoActivity";
import LoadingSpinner from "core/LoadingSpinner";
import MonthlyReport from "./monthly-report";

import {
    GET_PHOTO_ROYALTIES_STATEMENT_ALL,
    GET_POOL_PHOTO_ROYALTY_STATEMENTS
} from "./queries";

export const userHasPhotoActivity = statements => {
    // in some cases statements is null, or items is empty
    if (!statements?.items?.length) return false;

    // in some cases, all statements have no activity (totalEarned and freeDownloadCount are 0)
    return statements.items.some(
        s => parseFloat(s.totalEarned) > 0 || s.freeDownloadCount > 0
    );
};

const userHasNewPhotoActivity = statements => {
    if (!statements.length) return false;

    return statements.some(
        s =>
            parseFloat(s.earnings.subscription.photoEarnings) > 0 ||
            parseFloat(s.earnings.purchase.premiumPhotoEarnings) > 0 ||
            parseFloat(s.earnings.purchase.standardPhotoEarnings) > 0 ||
            s.counts.free.photoCount > 0
    );
};

const Royalties = ({ username }) => {
    const { data, loading } = useQuery(GET_PHOTO_ROYALTIES_STATEMENT_ALL, {
        variables: {
            username
        }
    });

    const {
        data: poolRoyaltiesData = { royaltyStatements: { statements: [] } },
        loading: loadingPoolRoyalties
    } = useQuery(GET_POOL_PHOTO_ROYALTY_STATEMENTS, {
        variables: {
            username
        }
    });

    if (loading || loadingPoolRoyalties) return <LoadingSpinner />;

    const {
        photoRoyaltyStatementsAndTotal: { statements }
    } = data;

    const {
        royaltyStatements: { statements: poolStatements }
    } = poolRoyaltiesData;

    // statements could be null, or have an empty array for items
    if (
        !userHasPhotoActivity(statements) &&
        !userHasNewPhotoActivity(poolStatements)
    ) {
        return <RoyaltiesNoActivity />;
    }

    return (
        <>
            <MonthlyReport
                username={username}
                statements={statements}
                poolStatements={poolStatements}
            />
        </>
    );
};

export default Royalties;
